import { render, staticRenderFns } from "./InputWrapper.vue?vue&type=template&id=21f36ee1&scoped=true&"
import script from "./InputWrapper.vue?vue&type=script&lang=js&"
export * from "./InputWrapper.vue?vue&type=script&lang=js&"
import style0 from "./InputWrapper.vue?vue&type=style&index=0&id=21f36ee1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f36ee1",
  null
  
)

export default component.exports